import { parse, isBefore, isEqual } from 'date-fns'
export default {
  params: ['dateToStr'],
  validate(value, { dateToStr }) {
    const enteredDate = parse(value, 'dd/MM/yyyy', new Date())
    const dateTo = parse(dateToStr, 'yyyy-MM-dd', new Date())
    return isBefore(enteredDate, dateTo) || isEqual(enteredDate, dateTo)
  },
}
